import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import { computed } from "vue";
import { useUserStore } from "@/store/user";
import MembersList from "@/components/groups/MembersList.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    members: {
      default: function _default() {
        return [];
      }
    },
    groupId: null,
    loader: null,
    owner: null,
    error: null
  },
  emits: ["retry", "unlink"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var userStore = useUserStore();
    var isOwner = computed(function () {
      var _props$owner, _userStore$user;

      return userStore.authenticated && ((_props$owner = props.owner) === null || _props$owner === void 0 ? void 0 : _props$owner.id) === ((_userStore$user = userStore.user) === null || _userStore$user === void 0 ? void 0 : _userStore$user.id);
    });
    var activeMembers = computed(function () {
      return props.members.filter(function (m) {
        return !m.pendingAcceptation;
      });
    });
    var pendingMembers = computed(function () {
      return props.members.filter(function (m) {
        return m.pendingAcceptation;
      });
    });
    return function (_ctx, _cache) {
      var _component_n_tab_pane = _resolveComponent("n-tab-pane");

      var _component_n_tabs = _resolveComponent("n-tabs");

      return !_unref(isOwner) || _unref(pendingMembers).length === 0 ? (_openBlock(), _createBlock(MembersList, {
        key: 0,
        members: _unref(activeMembers),
        groupId: __props.groupId,
        owner: __props.owner,
        loader: __props.loader,
        error: __props.error,
        onRetry: _cache[0] || (_cache[0] = function ($event) {
          return emit('retry');
        }),
        onUnlink: _cache[1] || (_cache[1] = function (user) {
          return emit('unlink', user);
        })
      }, null, 8, ["members", "groupId", "owner", "loader", "error"])) : (_openBlock(), _createBlock(_component_n_tabs, {
        key: 1,
        type: "line"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_tab_pane, {
            name: "my-groups",
            tab: "Active members"
          }, {
            default: _withCtx(function () {
              return [_createVNode(MembersList, {
                members: _unref(activeMembers),
                groupId: __props.groupId,
                owner: __props.owner,
                loader: __props.loader,
                error: __props.error,
                onRetry: _cache[2] || (_cache[2] = function ($event) {
                  return emit('retry');
                }),
                onUnlink: _cache[3] || (_cache[3] = function (user) {
                  return emit('unlink', user);
                })
              }, null, 8, ["members", "groupId", "owner", "loader", "error"])];
            }),
            _: 1
          }), _unref(isOwner) ? (_openBlock(), _createBlock(_component_n_tab_pane, {
            key: 0,
            name: "other-groups",
            tab: "Pending invitations"
          }, {
            default: _withCtx(function () {
              return [_createVNode(MembersList, {
                members: _unref(pendingMembers),
                groupId: __props.groupId,
                owner: __props.owner,
                loader: __props.loader,
                error: __props.error,
                "remove-label": "Cancel",
                "confirmation-text": "Are you sure you want to cancel this invitation?",
                onRetry: _cache[4] || (_cache[4] = function ($event) {
                  return emit('retry');
                }),
                onUnlink: _cache[5] || (_cache[5] = function (user) {
                  return emit('unlink', user);
                })
              }, {
                time: _withCtx(function (_ref2) {
                  var time = _ref2.time;
                  return [_createTextVNode("Invited " + _toDisplayString(time), 1)];
                }),
                _: 1
              }, 8, ["members", "groupId", "owner", "loader", "error"])];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }));
    };
  }
});